module.exports = __webpack_public_path__ + "img/Frame-2.5727a2e2.png";